// src/components/SceneLighting.jsx

import React from "react";
import { useControls } from "leva";
import { SpotLight, SoftShadows } from "@react-three/drei";

export default function SceneLighting() {
  return (
    <>
      <SoftShadows size={5} near={9.5} samples={16} focus={2} />
      <directionalLight
        position={[-80, 65, 80]}
        intensity={1.8}
        castShadow
        shadow-camera-top={350}
        shadow-camera-bottom={-350}
        shadow-camera-right={350}
        shadow-camera-left={-350}
        shadow-camera-near={0}
        shadow-mapSize={[1024, 1024]}
      />
      <directionalLight
        position={[80, -80, 160]}
        intensity={1.2}
        // castShadow
        shadow-camera-top={250}
        shadow-camera-bottom={-250}
        shadow-camera-right={250}
        shadow-camera-left={-250}
        shadow-camera-near={0}
        shadow-mapSize={[1024, 1024]}
      />
    </>
  );
}
